import { Autocomplete, Chip, TextField, Typography, Tooltip } from "@mui/material";
import { parametri_valutativi_cgg, parametri_valutativi_ccm, parametri_valutativi_icr, ParametroValutativo } from "../interfaces/Esercizio";
import { Stack } from "react-bootstrap";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';


type ParametriValutativiProps = {
    value_cgg: { key: string; value: number }[];
    value_ccm: { key: string; value: number }[];
    value_icr: { key: string; value: number }[];
    onChange: (group: string, value: { key: string; value: number }[]) => void;
};

const ParametriValutativi: React.FC<ParametriValutativiProps> = ({ value_cgg = [], value_ccm = [], value_icr = [], onChange }) => {
    const selectedOptions_cgg = value_cgg
        .map((item) => parametri_valutativi_cgg.find((p) => p.key === item.key))
        .filter((p): p is ParametroValutativo => p !== undefined);
    const selectedOptions_ccm = value_ccm
        .map((item) => parametri_valutativi_ccm.find((p) => p.key === item.key))
        .filter((p): p is ParametroValutativo => p !== undefined);

    const selectedOptions_icr = value_icr
        .map((item) => parametri_valutativi_icr.find((p) => p.key === item.key))
        .filter((p): p is ParametroValutativo => p !== undefined);

    const get_value = (group: string) => {
        return group=='cgg' ? value_cgg : group=='ccm' ? value_ccm : group=='icr' ? value_icr : [];
    };

    const get_selectedValues = (group: string) => {
        return group=='cgg' ? selectedOptions_cgg : group=='ccm' ? selectedOptions_ccm : group=='icr' ? selectedOptions_icr : [];
    };

    const handleAutocompleteChange = (group: string, newSelectedOptions: ParametroValutativo[]) => {
        const updated: { key: string; value: number }[] = [];

        newSelectedOptions.forEach((option) => {
            const value = get_value(group);
            const existingParam = value.find((v) => v.key === option.key);
            if (existingParam) {
                updated.push({ key: option.key, value: existingParam.value });
            } else {
                updated.push({ key: option.key, value: 0 });
            }
        });

        onChange(group, updated);
    };

    const handleAutocompleteChange_cgg = (event: any, newSelectedOptions: ParametroValutativo[]) => {
        handleAutocompleteChange('cgg', newSelectedOptions);
    };

    const handleAutocompleteChange_ccm = (event: any, newSelectedOptions: ParametroValutativo[]) => {
        handleAutocompleteChange('ccm', newSelectedOptions);
    };

    const handleAutocompleteChange_icr = (event: any, newSelectedOptions: ParametroValutativo[]) => {
        handleAutocompleteChange('icr', newSelectedOptions);
    };

    const handleIncrement = (group: string, key: string) => {
        const value = get_value(group);
        const updated = value.map((item) => {
            if (item.key === key) {
                return {
                    ...item,
                    value: Math.min(1, +(item.value + 0.1).toFixed(1)),
                };
            }
            return item;
        });
        onChange(group, updated);
    };

    const handleDecrement = (group: string, key: string) => {
        const value = get_value(group);
        const updated = value.map((item) => {
            if (item.key === key) {
                return {
                    ...item,
                    value: Math.max(0, +(item.value - 0.1).toFixed(1)),
                };
            }
            return item;
        });
        onChange(group, updated);
    };

    const handleDelete = (group: string, key: string) => {
        const value = get_value(group);
        const updated = value.filter((item) => item.key !== key);
        onChange(group, updated);
    };

    const getSelectedOptions = (group: string) => {
        const value = get_value(group);
        const selectedOptions = get_selectedValues(group);
        return selectedOptions.length > 0 && (
            <div style={{ marginTop: '1rem' }}>
                <Typography variant="subtitle1">Metriche selezionate:</Typography>

                <div >
                    {selectedOptions.map((param) => (
                        <div className="row mt-3" key={param.key} >
                            <div className="col" style={{ maxWidth: '55%' }}>
                                <Tooltip title={param.label} arrow>
                                    <Chip
                                        label={param.label}
                                        onDelete={() => handleDelete(group, param.key)}
                                    />
                                </Tooltip>
                            </div>

                            <div className="col d-flex justify-content-end">
                                <button
                                    className="btn btn-dark"
                                    onClick={() => handleDecrement(group, param.key)}
                                    style={{
                                        width: "40px",
                                        padding: "0px"
                                    }}
                                >
                                    <RemoveIcon />
                                </button>
                                <input
                                    type="text"
                                    disabled
                                    className="form-control mx-3 text-center"
                                    value={value.find((v) => v.key === param.key)?.value.toFixed(1)}
                                    style={{
                                        width: "70px"
                                    }}
                                />
                                <button
                                    className="btn btn-dark"
                                    onClick={() => handleIncrement(group, param.key)}
                                    style={{
                                        width: "40px",
                                        padding: "0px"
                                    }}
                                >
                                    <AddIcon />
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        )
    };

    return (
        <>
        <div >
            <div className="row mb-2">
                <h5 className="font-semibold mb-1">Metriche C.G.G.</h5>
            </div>
            <Autocomplete
                multiple
                disableClearable
                disableCloseOnSelect
                options={parametri_valutativi_cgg}
                getOptionLabel={(option) => option.label}
                value={selectedOptions_cgg}
                onChange={handleAutocompleteChange_cgg}
                renderTags={(value: ParametroValutativo[], getTagProps) => {return (<></>)}
                    /*value.map((option, index) => (
                        <Chip
                            variant="outlined"
                            label={option.label}
                            {...getTagProps({ index })}
                            key={option.key}
                        />
                    ))*/
                }
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="outlined"
                        label="Seleziona metriche"
                        placeholder="Metriche"
                        InputProps={{
                            ...params.InputProps,
                            style: {
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            },
                        }}
                    />
                )}
            />

            {getSelectedOptions('cgg')}
        </div>

        {parametri_valutativi_ccm.length > 0 && (
        <div >
            <div className="row mb-2">
                <h5 className="font-semibold mb-1">Metriche C.C.M.</h5>
            </div>
            <Autocomplete
                multiple
                disableClearable
                disableCloseOnSelect
                options={parametri_valutativi_ccm}
                getOptionLabel={(option) => option.label}
                value={selectedOptions_ccm}
                onChange={handleAutocompleteChange_ccm}
                renderTags={(value: ParametroValutativo[], getTagProps) => {return (<></>)}
                    /*value.map((option, index) => (
                        <Chip
                            variant="outlined"
                            label={option.label}
                            {...getTagProps({ index })}
                            key={option.key}
                        />
                    ))*/
                }
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="outlined"
                        label="Seleziona metriche"
                        placeholder="Metriche"
                        InputProps={{
                            ...params.InputProps,
                            style: {
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            },
                        }}
                    />
                )}
            />

            {getSelectedOptions('ccm')}
        </div>
        )}

        {parametri_valutativi_icr.length > 0 && (
        <div >
            <div className="row mb-2">
                <h5 className="font-semibold mb-1">Metriche I.C.R</h5>
            </div>
            <Autocomplete
                multiple
                disableClearable
                disableCloseOnSelect
                options={parametri_valutativi_icr}
                getOptionLabel={(option) => option.label}
                value={selectedOptions_icr}
                onChange={handleAutocompleteChange_icr}
                renderTags={(value: ParametroValutativo[], getTagProps) => {return (<></>)}
                    /*value.map((option, index) => (
                        <Chip
                            variant="outlined"
                            label={option.label}
                            {...getTagProps({ index })}
                            key={option.key}
                        />
                    ))*/
                }
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="outlined"
                        label="Seleziona metriche"
                        placeholder="Metriche"
                        InputProps={{
                            ...params.InputProps,
                            style: {
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            },
                        }}
                    />
                )}
            />

            {getSelectedOptions('icr')}
        </div>
        )}
        </>
    );
};

export default ParametriValutativi
